export default {
  setLoaded({ commit }, loaded) {
    commit('setLoaded', loaded)
  },
  setAllowSuggestions({ commit }, allowSuggestions) {
    commit('setAllowSuggestions', allowSuggestions)
  },
  setOffline({ commit }, offline) {
    commit('setOffline', offline)
  },
  setNominees({ commit }, nominees) {
    commit('setNominees', nominees)
  },
  setCategories({ commit }, categories) {
    commit('setCategories', categories)
  },
  setFrontend({ commit }, frontend) {
    commit('setFrontend', frontend)
  },
  setRounds({ commit }, rounds) {
    commit('setRounds', rounds)
  },
  setShowtimesTags({ commit }, showtimeTags) {
    commit('setShowtimesTags', showtimeTags)
  },
  setStationsTags({ commit }, stationsTags) {
    commit('setStationsTags', stationsTags)
  },
  selectNominee({ commit }, { categoryId, nomineeId }) {
    commit('selectNominee', { categoryId, nomineeId })
  },
  addSuggestion({ commit }, { categoryId, suggestionName, suggestionStation }) {
    commit('addSuggestion', { categoryId, suggestionName, suggestionStation })
  },
  clearSelected({ commit }) {
    commit('clearSelected')
  },
  clearCategory({ commit }, { categoryId }) {
    commit('clearCategory', { categoryId })
  },
  setSelectedChannelId({ commit }, { categoryId, tagId }) {
    commit('setSelectedChannelId', { categoryId, tagId })
  },
  setSelectedDayPartId({ commit }, { categoryId, tagId }) {
    commit('setSelectedDayPartId', { categoryId, tagId })
  },
  setKeyword({ commit }, { categoryId, keyword }) {
    commit('setKeyword', { categoryId, keyword })
  },
  setSortType({ commit }, { categoryId, sortType }) {
    commit('setSortType', { categoryId, sortType })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js